'use client';

import React from 'react';
import { twMerge } from 'tailwind-merge';
import { PulseButton, PulseIconButton } from 'src/components/PulseUI';
import { faRoute } from '@fortawesome/pro-solid-svg-icons';

interface AddToRouteButtonProps {
  onClick: () => void;
  count?: number;
  className?: string;
  variant?: 'solid' | 'outline' | 'soft' | 'plain';
  color?: 'primary' | 'neutral' | 'success' | 'danger' | 'secondary';
  size?: 'sm' | 'md' | 'lg';
  compact?: boolean;
}

const AddToRouteButton: React.FC<AddToRouteButtonProps> = ({
  onClick,
  className,
  count,
  color = 'primary',
  variant = 'solid',
  size = 'sm',
  compact = false,
}) => {
  const ariaLabel =
    count && count > 0 ? `Add ${count} to route` : 'Add to route';

  if (compact) {
    return (
      <PulseIconButton
        color={color}
        variant={variant}
        size={size}
        onClick={onClick}
        className={className}
        tooltip="Add to Route"
        data-testid="add-to-route-button"
        aria-label={ariaLabel}
        icon={faRoute}
      />
    );
  }

  return (
    <PulseButton
      size={size}
      color={color}
      variant={variant}
      onClick={onClick}
      className={twMerge('w-full whitespace-nowrap', className)}
      data-testid="add-to-route-button"
      aria-label={ariaLabel}
      startDecorator={faRoute}
    >
      {count && count > 0 ? `Add ${count} to Route` : 'Add to Route'}
    </PulseButton>
  );
};

export default AddToRouteButton;
